module.exports = __webpack_public_path__ + "img/MT.a1e9f8a8.png";